import { type DiscountDTO, type ProductLightDTO, type ProductPrice } from 'ecosystem'

export const getProductOriginalPrice = (product: ProductPrice): number => {
  return product.originalPrice ?? 0
}

export const getProductPrice = (product: ProductPrice): number => {
  return product.price ?? getProductOriginalPrice(product)
}

const isDiscountApplicableToProduct = (product: ProductLightDTO, discountCode: DiscountDTO) => {
  return (
    (product.brand?.id && discountCode.brandIds?.includes(product.brand.id)) ||
    discountCode.categoryIds?.some((c) => product.categoryIds?.includes(c)) ||
    discountCode.tagIds?.some((t) => product.tags?.map((pTag) => pTag.id).includes(t))
  )
}

export const getProductDiscountPrice = (
  product: ProductLightDTO,
  discountCode: DiscountDTO | null
):
  | {
      discountedPrice: number
      priceUsedForDiscount: number
    }
  | undefined => {
  if (!discountCode || !isDiscountApplicableToProduct(product, discountCode)) {
    return undefined
  }

  const discountRate = discountCode.value / 100
  const itemPrice = getProductPrice(product)
  const itemOriginalPrice = getProductOriginalPrice(product)
  const isOriginalPriceLower = itemPrice > itemOriginalPrice

  if (!discountCode.campaign && !isOriginalPriceLower) {
    const itemDiscount = itemOriginalPrice * discountRate

    return {
      priceUsedForDiscount: itemOriginalPrice,
      discountedPrice: itemOriginalPrice - itemDiscount
    }
  }

  const itemDiscount = itemPrice * discountRate

  return {
    priceUsedForDiscount: itemPrice,
    discountedPrice: itemPrice - itemDiscount
  }
}
